import { Flex, Table } from 'antd'
import { BudgetCoinLoader } from 'src/pages/budget/components'
import { useBudgetUserList } from 'src/pages/budget/budgetTeams/hooks'
import { useUserListGate } from 'src/pages/budget/budgetTeams/hooks'
import { columnsUserList } from 'src/pages/budget/budgetTeams/widgets/users/columnsUserList'

export const UserSection = () => {
  const { userList, loadingUserList } = useBudgetUserList()
  useUserListGate()

  if (loadingUserList) {
    return <BudgetCoinLoader />
  }

  return (
    <Table
      dataSource={userList}
      size="large"
      scroll={{ x: true }}
      columns={columnsUserList}
      pagination={{
        total: userList.length,
        position: ['bottomCenter'],
      }}
      rowKey={(record) => record.userId}
      rowClassName={(_, index) =>
        `ant_table_row_height ${index % 2 ? 'even-row' : 'odd-row'}`
      }
    />
  )
}
